import React, { useEffect, useRef, useState } from 'react'
import LabelText from '../../../ui/LabelText';
import CustomButton from '../../../ui/Button';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LabelNumber from '../../../styled-components/LabelNumber';
import { usePitchWidgetContext } from '../../../contexts/PitchWidgetContext';
import { fetchChemistryData, fetchEventTimeline, fetchFormationData, fetchMatchInformationData, fetchMatchTimeline, fetchMatchTimelineZoomLevel2, fetchOverallFormationData, fetchPlayerCardData, fetchPlayerPassingNetworks, fetchPlayersData, fetchSeasonData } from '../../../pages/Chemistry/Utils';
import { useLoading } from '../../../contexts/LoadingContext';
import { IDisabledButtonsState, IInjuryEvents, IMatches, IMatchInfo, IMatchLevelEvents, ITeamMatchByMonths } from '../../../types/ITimeline';
import Timeline, { SelectedData } from '../../Timeline';
import { ChemistryPlayerPositions, FormationData, IOption, IPlayerData, TeamChemistry } from '../../../types/IOption';
import SecondaryButton from '../../../ui/SecondaryButton';
import { IndividualStatContainer, MatchTimeLineWrapper, MatchTrackContainer } from '../../../pages/Chemistry/StyledChemistryElements';
import MatchTimeLine from '../../MatchTimeline';
import EventTimeLine from '../../EventTimeline';
import { IMatchEventCardData } from '../../../types/IMatchEventCardData';
import { ButtonKey } from '../../../pages/Chemistry';
import { CurrentView } from '../../../types/IPitchProps';
import Pitch from '../../Pitch';
import { FormationSelectDrawer } from '../../../pages/Chemistry/UIContent';
import Switch from '../../../ui/CustomSwitch';
import { timelineVisRestrictions } from "../../../pages/Chemistry/static";
import { IPlayerCardDetail } from '../../../types/IPlayerCardDetail';
import PlayerLandingCard from '../../../ui/CardComponent';
import { teamSegmentGameModelGroup } from '../Performance/GameModel';
import IApiResponse from '../../../types/IApiResponse';
import handleApiResponse from '../../../utils/handleApiResponse';
import { IGameModel } from '../../../types/IClubDetail';
import { postData } from '../../../services/api';
import apiUrls from '../../../config/apiUrls';


interface IPossessionsProps {
    teamId: number
}

const Possessions: React.FC<IPossessionsProps> = ({ teamId }) => {

    const { loading, startLoading, stopLoading } = useLoading();
    const [timeLineDrawerOpen, setTimeLineDrawerOpen] = useState<boolean>(false);
    // const { zoomLevelId, timeLineTag,matchDate ,setTimeLineTag } = usePitchWidgetContext();
    const [matches, setMatches] = useState<any[]>([]);
    const [disabledButtons, setDisabledButtons] = useState<IDisabledButtonsState>({
        play: true,
        previous: true,
        zoomOut: true,
        zoomIn: true,
        next: true,
    });
    const [selectedSeasonId, setSelectedSeasonId] = useState<number>(0);
    const [seasonName, setSeasonName] = useState<string>("");
    const [teamMatchesByMonth, setTeamMatchesByMonth] = useState<ITeamMatchByMonths[]>([]);
    const [seasonData, setSeasonData] = useState<IOption[]>([]);
    const [selectedMatch, setSelectedMatch] = useState<number>(0);
    const [displayedMatches, setDisplayedMatches] = useState<IMatches[]>([]);
    const [groupIndex, setGroupIndex] = useState<number>(0);
    const matchesPerPage = 13;
    const totalGroups = Math.ceil(matches.length / matchesPerPage);
    const [previousMatchId, setPreviousMatchId] = useState<number>(0);
    const [direction, setDirection] = useState<string>("previous");
    const [isDisplayMatchEventInfo, setIsDisplayMatchEventInfo] = useState<boolean>(false);
    const [matchEventInfo, setMatchEventInfo] = useState<IMatchEventCardData | null>();
    const [zoomLevelId, setZoomLevelId] = useState<1 | 2 | 3 | 4>(4);
    const [thirdOfSeason, setThirdOfSeason] = useState<string>("FinalThird");
    const [timeLineTag, setTimeLineTag] = useState<string>("");
    const [matchDate, setMatchDate] = useState<string>("");
    const [formationData, setFormationData] = useState<FormationData[]>([]);
    const [selectedFormation, setSelectedFormation] = useState<number>(0);
    const [currentView, setCurrentView] = useState<CurrentView>("passingNetwork");
    const [injuryEvents, setInjuryEvents] = useState<IInjuryEvents>();
    const [matchEndTime, setMatchEndTime] = useState<number>(0);
    const [matchLevelEvents, setMatchLevelEvents] = useState<IMatchLevelEvents[]>([]);
    const [matchInfo, setMatchInfo] = useState<IMatchInfo>();
    const [playerData, setPlayerData] = useState<IPlayerData[]>([]);
    const [currentPlayView, setCurrentPlayView] = useState<CurrentView>("minus");
    const [isNotification, setIsNotification] = useState<boolean>(false);
    const [selectedPNFormation, setSelectedPNFormation] = useState<number>(0);
    const [isActualPositionToggled, setIsActualPositionToggled] = useState<boolean>(false);
    const [passNetworkPlayers, setPassNetworkPlayers] = useState<ChemistryPlayerPositions[]>([]);
    const [passNetworkPlayerPasses, setPassNetworkPlayerPasses] = useState<any[]>([]);
    const [lastPassNetworkPlayers, setLastPassNetworkPlayers] = useState<ChemistryPlayerPositions[]>([]);
    const [lastPassNetworkPlayerPasses, setLastPassNetworkPlayerPasses] = useState<any[]>([]);
    const [pnSwapActive, setPNSwapActive] = useState<boolean>(false);
    const [PNFormationData, setPNFormationData] = useState<FormationData[]>([]);
    const [isIndividualPassing, setIsIndividualPassing] = useState<boolean>(false);
    const [swapHoverPlayer, setSwapHoverPlayer] = useState<number>(0);
    const [sidebarFormationOpen, setSidebarFormationOpen] = useState<boolean>(false);
    const [playerCardID, setPlayerCardID] = useState<number>(0);
    const [playerCardDetails, setPlayerCardDeatils] = useState<IPlayerCardDetail | undefined>();
    const playerCardRef = useRef(null);
    const [positionResults, setPositionResults] = useState<ChemistryPlayerPositions[]>([]);
    const [teamChemistry, setTeamChemistry] = useState<TeamChemistry[]>([]);
    const [lastPositionResults, setLastPositionResults] = useState<ChemistryPlayerPositions[]>([]);
    const [lastTeamChemistry, setLastTeamChemistry] = useState<TeamChemistry[]>([]);
    const [isDisplayInitialRect, setIsDisplayInitialRect] = useState<boolean>(true);
    const [isChemistryDataNotEnough, setIsChemistryDataNotEnough] = useState<boolean>(false);
    const [selectedAttributes, setSelectedAttributes] = useState<string[]>([
          "crosses",
          "passes_to_final_third",
          "shots",
          "defensive_duels"
    ]);
    const [gameModelData, setGameModelData] = useState<IGameModel[]>([])
    const matchIds = matches.map(m => m.matchId);


      const handleGameModelAttributesSelection = (key: string) => {
              setSelectedAttributes(prev =>
                prev.includes(key)
                  ? prev.filter(item => item !== key)
                  : [...prev, key]
              );
          };
      
          const fetchGamneModelData = async () => {
              startLoading();
              try {
                const response: IApiResponse<IGameModel[]> = await postData(`${apiUrls["GetGameModel"]}`, {
                  seasonId: selectedSeasonId,
                  teamId: teamId,
                  matchIds : selectedMatch > 0 ? [selectedMatch] : matchIds,
                  plotAll : true,
                  typeFilter: selectedAttributes
                });
          
                handleApiResponse(
                  response,
                  (gameModelData) => {
                    stopLoading();
                    setGameModelData(gameModelData);
                  },
                  (error) => {
                    stopLoading();
                    console.error("Error fetching Game Model Data:", error);
                  }
                );
              } catch (error) {
                stopLoading();
                console.error("Unexpected error while Game Model Data:", error);
              }
          };
      
          useEffect(()=>{
            // if(teamId! > 0 && selectedSeasonId! > 0) {
              fetchGamneModelData();
            // }
          },[teamId!,selectedSeasonId!,selectedAttributes, selectedMatch])
    
    
      useEffect(() => {
        if (playerCardID > 0) {
          fetchPlayerCardData(startLoading, stopLoading, playerCardID, setPlayerCardDeatils);
        } else {
          setPlayerCardDeatils(undefined);
        }
      }, [playerCardID]);

        const handleClickOutside = (event: MouseEvent) => {
            if (playerCardRef.current) {
            // @ts-ignore
            if (!playerCardRef.current?.contains(event.target)) {
                setPlayerCardDeatils(undefined);
                setPlayerCardID(0);
            }
            }
        };

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

      useEffect(() => {
        const reversedMatches = matches.slice().reverse(); // Reverse the order of matches
        const startIndex = groupIndex * matchesPerPage;
        const endIndex = startIndex + matchesPerPage;
        let newDisplayedMatches;
        if (matches.length < matchesPerPage) {
          newDisplayedMatches = reversedMatches.slice(startIndex, endIndex);
        } else {
          const rever = reversedMatches.reverse().slice(startIndex, endIndex);
          newDisplayedMatches = rever.reverse();
        }
        // const newDisplayedMatches = matches.length < matchesPerPage ?
        //   reversedMatches.slice(startIndex, endIndex)
        //   : reversedMatches.reverse().slice(startIndex, endIndex);
    
        setDisplayedMatches(newDisplayedMatches);
      }, [matches, groupIndex, matchesPerPage]);
    
    
     const fetchMatchTimelineZoom2 = async (
        thirdOfSeason: string,
        isPrevious: boolean,
        isNext: boolean,
        newZoomLevel: number,
        team: number,
        seasonId?: number
      ) => {
        const currentSeasonId = seasonId ?? selectedSeasonId;
        await fetchMatchTimelineZoomLevel2(
          startLoading,
          team,
          setMatches,
          setDisabledButtons,
          setSelectedSeasonId,
          currentSeasonId,
          thirdOfSeason,
          isPrevious,
          isNext,
          newZoomLevel,
          setTimeLineTag,
          setSeasonName,
          async (updatedMatches, updatedSeasonId) => {
            const matchIds = updatedMatches.map((match) => match.matchId);
        
          },
        //   setDrawCount,
        //   setLossCount,
        //   setWinCount
        );
      };
      const getNewZoomLevel = (currentZoomLevel: 1 | 2 | 3 | 4, buttonKey: ButtonKey): 1 | 2 | 3 | 4 => {
        switch (buttonKey) {
          case "zoomIn":
            return currentZoomLevel === 4 ? 3 : currentZoomLevel === 3 ? 2 : currentZoomLevel === 2 ? 1 : currentZoomLevel;
          case "zoomOut":
            return currentZoomLevel === 3 ? 4 : currentZoomLevel === 1 ? 2 : currentZoomLevel === 2 ? 3 : currentZoomLevel;
          case "previous":
          case "next":
            return currentZoomLevel === 2 ? 2 : currentZoomLevel;
          default:
            return currentZoomLevel;
        }
      };

    //   const handleZoomLevel2 = async (newZoomLevel: number, isPrevious: boolean, isNext: boolean) => {
    //     setSelectedMatch(0);
    //     let newThirdOfSeason = thirdOfSeason;
    //     if (isPrevious) {
    //       newThirdOfSeason = thirdOfSeason === "FinalThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FirstThird" : thirdOfSeason;
    //     } else if (isNext) {
    //       newThirdOfSeason = thirdOfSeason === "FirstThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FinalThird" : thirdOfSeason;
    //     }
    //     setThirdOfSeason(newThirdOfSeason);
    //     await fetchMatchTimelineZoom2(newThirdOfSeason, isPrevious, isNext, newZoomLevel, teamId);
    //     setPreviousMatchId(selectedMatch);
    //   };
    //   const handleZoomLevel1 = async (isPrevious: boolean, isNext: boolean, matchId?: number) => {
    //     let MatchId: number = 0;
    //     let PlayerId: number = 0;
    //     await fetchEventTimeline(
    //       startLoading,
    //       stopLoading,
    //       selectedTeam,
    //       matchId ?? selectedMatch,
    //       setInjuryEvents,
    //       setMatchEndTime,
    //       setMatchLevelEvents,
    //       setMatchInfo,
    //       setSelectedMatch,
    //       setTimeLineTag,
    //       setDisabledButtons,
    //       isPrevious,
    //       isNext,
    //       setMatchDate,
    //       (updatedMatchId) => {
    //         MatchId = updatedMatchId;
    //       }
    //     );
    //     await fetchPlayersData(startLoading, stopLoading, selectedTeam, MatchId ?? 0, setPlayerData, (playerData) => {
    //       const playerExists = playerData.some((player) => player.value === passingAttackPlayerId);
    //       if (playerExists) {
    //         PlayerId = playerData.find((player) => player.value === passingAttackPlayerId)?.value ?? 0;
    //       } else {
    //         setPassingAttackPlayerId(0);
    //         setPassingAttackData([]);
    //       }
    //     });
    //   };
    

    useEffect(()=>{
        if(teamId > 0){
            fetchSeasonData(startLoading, stopLoading, teamId, setSeasonData)
        }
    },[teamId])

      const handleZoomLevel3 = async (newZoomLevel: number, isPrevious: boolean, isNext: boolean, seasonId: number) => {
        // const shouldFetchData = currentPlayView === "threatMap" || currentView === "areasOfControl" || currentView === "systemFit";
        const fetchData = async (updatedMatches: any[], updatedSeasonId: number) => {
          const matchIds = updatedMatches.map((match) => match.matchId);
    
        };
    
        await fetchMatchTimeline(
          startLoading,
          stopLoading,
          teamId,
          setMatches,
          setDisabledButtons,
          setSelectedSeasonId,
          seasonId,
          isPrevious,
          isNext,
          newZoomLevel,
          setTeamMatchesByMonth,
          setTimeLineTag,
          setSeasonName,
          false,
          fetchData
        );
      };
      const handleZoomLevel2 = async (newZoomLevel: number, isPrevious: boolean, isNext: boolean) => {
        setSelectedMatch(0);
        let newThirdOfSeason = thirdOfSeason;
        if (isPrevious) {
          newThirdOfSeason = thirdOfSeason === "FinalThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FirstThird" : thirdOfSeason;
        } else if (isNext) {
          newThirdOfSeason = thirdOfSeason === "FirstThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FinalThird" : thirdOfSeason;
        }
        setThirdOfSeason(newThirdOfSeason);
        await fetchMatchTimelineZoom2(newThirdOfSeason, isPrevious, isNext, newZoomLevel, teamId);
        setPreviousMatchId(selectedMatch);
      };
      const handleZoomLevel1 = async (isPrevious: boolean, isNext: boolean, matchId?: number) => {
        let MatchId: number = 0;
        let PlayerId: number = 0;
        // await fetchEventTimeline(
        //   startLoading,
        //   stopLoading,
        //   teamId,
        //   matchId ?? selectedMatch,
        //   setInjuryEvents,
        //   setMatchEndTime,
        //   setMatchLevelEvents,
        //   setMatchInfo,
        //   setSelectedMatch,
        //   setTimeLineTag,
        //   setDisabledButtons,
        //   isPrevious,
        //   isNext,
        //   setMatchDate,
        //   (updatedMatchId) => {
        //     MatchId = updatedMatchId;
        //   }
        // );
        // await fetchPlayersData(startLoading, stopLoading, teamId, MatchId ?? 0, setPlayerData, (playerData) => {
        //   const playerExists = playerData.some((player) => player.value === passingAttackPlayerId);
        //   if (playerExists) {
        //     PlayerId = playerData.find((player) => player.value === passingAttackPlayerId)?.value ?? 0;
        //   } else {
        //     setPassingAttackPlayerId(0);
        //     setPassingAttackData([]);
        //   }
        // });
    
        // if (currentView === "passingNetwork") {
        //   setCurrentView("passingNetwork");
        //   setCurrentPlayView("minus");
        //   setSelectedPNFormation(0);
        //   // await fetchPlayersData(startLoading, stopLoading, selectedTeam, MatchId ?? 0, setPlayerData);
        //   if (isActualPositionToggled) {
        //     await fetchPlayerPassingNetworks(
        //       teamId,
        //       MatchId ?? 0,
        //       selectedPNFormation,
        //       startLoading,
        //       stopLoading,
        //       isActualPositionToggled,
        //       setPassNetworkPlayers,
        //       setPassNetworkPlayerPasses,
        //       setLastPassNetworkPlayers,
        //       setLastPassNetworkPlayerPasses
        //     );
        //   } else {
        //     setPNSwapActive(false);
        //     setIsIndividualPassing(false);
        //     const formationId = await fetchFormationData(
        //       teamId,
        //       selectedSeasonId,
        //       startLoading,
        //       stopLoading,
        //       setPNFormationData,
        //       setSelectedPNFormation,
        //       [MatchId],
        //       true
        //     );
        //     await fetchPlayerPassingNetworks(
        //       teamId,
        //       MatchId ?? 0,
        //       formationId ?? selectedPNFormation,
        //       startLoading,
        //       stopLoading,
        //       isActualPositionToggled,
        //       setPassNetworkPlayers,
        //       setPassNetworkPlayerPasses,
        //       setLastPassNetworkPlayers,
        //       setLastPassNetworkPlayerPasses
        //     );
        //   }
        // }
      };

     const handleConfirm = async (selectedData: SelectedData) => {
         const { zoomLevelId, seasonId, selectedOption, matchId, overall } = selectedData;
         setZoomLevelId(zoomLevelId);
         setSelectedSeasonId(seasonId);
         setThirdOfSeason(selectedOption!!);
          if (overall) {
               await fetchOverallFormationData(teamId, setFormationData, setSelectedFormation);
               setMatches([]);
               setDisabledButtons({
                 play: true,
                 previous: true,
                 zoomOut: true,
                 zoomIn: false,
                 next: true,
               });
               //setIsNotification(false);
               //setNotificationContent('');
             } else {
               if (zoomLevelId === 2) fetchMatchTimelineZoom2(selectedData.selectedOption!!, false, false, 2, teamId, selectedData.seasonId);
               else if (zoomLevelId === 3) handleZoomLevel3(zoomLevelId, false, false, selectedData.seasonId);
               else if (zoomLevelId === 1) {
                 if (currentView === "passingNetwork") {
                //    handleZoomLevel1(false, false, matchId);
                //    fetchEventTimeline(
                //      startLoading,
                //      stopLoading,
                //      teamId,
                //      matchId,
                //      setInjuryEvents,
                //      setMatchEndTime,
                //      setMatchLevelEvents,
                //      setMatchInfo,
                //      setSelectedMatch,
                //      setTimeLineTag,
                //      setDisabledButtons,
                //      false,
                //      false,
                //      setMatchDate
                //    );
                 } else {
                //    fetchEventTimeline(
                //      startLoading,
                //      stopLoading,
                //      teamId,
                //      matchId,
                //      setInjuryEvents,
                //      setMatchEndTime,
                //      setMatchLevelEvents,
                //      setMatchInfo,
                //      setSelectedMatch,
                //      setTimeLineTag,
                //      setDisabledButtons,
                //      false,
                //      false,
                //      setMatchDate
                //    );
                 }
               }
               if (isDisplayMatchEventInfo) {
                 fetchMatchInformationData(matchId, startLoading, stopLoading, setMatchEventInfo, setMatchDate, (matchEventData) => {
                   matchEventData !== null && setIsDisplayMatchEventInfo(true);
                 });
               }
             }
      };

    const handleLeftClick = () => {
        setGroupIndex((prevIndex) => Math.min(prevIndex + 1, totalGroups - 1));
    };
    // Handle right button click
    const handleRightClick = () => {
        setGroupIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    };

    const handleSelectMatch = async (matchId: number) => {
      // fetchGamneModelData([matchId]);
      setSelectedMatch(matchId);

        try {
          startLoading();
          const selectedMatchId = await fetchEventTimeline(
            startLoading,
            stopLoading,
            teamId,
            matchId,
            setInjuryEvents,
            setMatchEndTime,
            setMatchLevelEvents,
            setMatchInfo,
            setSelectedMatch,
            setTimeLineTag,
            setDisabledButtons,
            false,
            false,
            setMatchDate
          );
          await fetchPlayersData(startLoading, stopLoading, teamId, matchId ?? 0, setPlayerData);
          setSelectedMatch(matchId);
          setZoomLevelId(1);
          if (currentView === "passingNetwork") {
            setCurrentView("passingNetwork");
            setCurrentPlayView("minus");
            setIsNotification(false);
            setSelectedPNFormation(0);
            if (isActualPositionToggled) {
              await fetchPlayerPassingNetworks(
                teamId,
                matchId ?? 0,
                selectedPNFormation,
                startLoading,
                stopLoading,
                isActualPositionToggled,
                setPassNetworkPlayers,
                setPassNetworkPlayerPasses,
                setLastPassNetworkPlayers,
                setLastPassNetworkPlayerPasses
              );
            } else {
              setPNSwapActive(false);
              setIsIndividualPassing(false);
              const formationId = await fetchFormationData(
                teamId,
                selectedSeasonId,
                startLoading,
                stopLoading,
                setPNFormationData,
                setSelectedPNFormation,
                [matchId],
                true
              );
              await fetchPlayerPassingNetworks(
                teamId,
                matchId ?? 0,
                formationId !== null ? formationId : selectedPNFormation,
                startLoading,
                stopLoading,
                isActualPositionToggled,
                setPassNetworkPlayers,
                setPassNetworkPlayerPasses,
                setLastPassNetworkPlayers,
                setLastPassNetworkPlayerPasses
              );
              stopLoading();
            }
          }
        } catch (error) {
          stopLoading();
          console.error("Error fetching data: ", error);
        }
      };

        const handleActualPositionSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
          event.stopPropagation();
          setIsActualPositionToggled((prev) => !prev);
          setIsIndividualPassing(false);
          setPNSwapActive(false);
          if (isActualPositionToggled) {
            fetchFormationData(
              teamId,
              selectedSeasonId,
              startLoading,
              stopLoading,
              setPNFormationData,
              setSelectedPNFormation,
              [selectedMatch],
              true
            );
            startLoading();
            fetchPlayerPassingNetworks(
              teamId,
              selectedMatch,
              selectedPNFormation,
              startLoading,
              stopLoading,
              false,
              setPassNetworkPlayers,
              setPassNetworkPlayerPasses,
              setLastPassNetworkPlayers,
              setLastPassNetworkPlayerPasses
            );
          } else {
            setPNFormationData([]);
            fetchPlayerPassingNetworks(
              teamId,
              selectedMatch,
              selectedPNFormation,
              startLoading,
              stopLoading,
              true,
              setPassNetworkPlayers,
              setPassNetworkPlayerPasses,
              setLastPassNetworkPlayers,
              setLastPassNetworkPlayerPasses
            );
          }
        };


          const handlePNFormationChange = (formationId: number) => {
            setSelectedPNFormation(formationId);
            setPNSwapActive(false);
            setIsIndividualPassing(false);
            startLoading();
            fetchPlayerPassingNetworks(
              teamId,
              selectedMatch,
              formationId,
              startLoading,
              stopLoading,
              isActualPositionToggled,
              setPassNetworkPlayers,
              setPassNetworkPlayerPasses,
              setLastPassNetworkPlayers,
              setLastPassNetworkPlayerPasses
            ).finally(stopLoading);
          };


    const toggleButtonState = async (buttonKey: ButtonKey) => {
        const newZoomLevel = getNewZoomLevel(zoomLevelId, buttonKey);
        setDirection(buttonKey === "previous" ? "previous" : "next");
        switch (newZoomLevel) {
          case 4:
            await fetchOverallFormationData(teamId, setFormationData, setSelectedFormation);
            await fetchChemistryData(
              teamId,
              0,
              setPositionResults,
              setTeamChemistry,
              startLoading,
              stopLoading,
              0,
              setLastTeamChemistry,
              setLastPositionResults,
              setIsDisplayInitialRect,
              true,
              [],
              setIsChemistryDataNotEnough,
              setFormationData,
              setSelectedFormation
            );
            setMatches([]);
            setZoomLevelId(newZoomLevel);
            setDisabledButtons((prevState) => ({
              ...prevState,
              play: true,
              previous: true,
              next: true,
              zoomIn: false,
              zoomOut: true,
            }));
            break;
          case 3:
            await handleZoomLevel3(newZoomLevel, buttonKey === "previous", buttonKey === "next", selectedSeasonId);
            setZoomLevelId(newZoomLevel);
            break;
          case 2:
            await handleZoomLevel2(newZoomLevel, buttonKey === "previous", buttonKey === "next");
            // setTimeout(()=>{
            setZoomLevelId(newZoomLevel);
            setDirection(buttonKey === "previous" ? "previous" : "next");
            setMatchEventInfo(null);
            setIsDisplayMatchEventInfo(false);
            // },3000)
            break;
          case 1:
            await handleZoomLevel1(buttonKey === "previous", buttonKey === "next");
            // setTimeout(()=>{
            setZoomLevelId(newZoomLevel);
            setDirection(buttonKey === "previous" ? "previous" : "next");
            // },3000)
            break;
          default:
            await handleZoomLevel1(buttonKey === "previous", buttonKey === "next");
            // setTimeout(()=>{
            setZoomLevelId(newZoomLevel);
            setDirection(buttonKey === "previous" ? "previous" : "next");
            // },3000)
            break;
        }
      };

    
    return (
        <div style={{ width:'inherit', padding:'0px'}}>
            <div className="common-squad-systemfit" style={{ paddingTop: '40px' }}>
                {teamId > 0 && (
                    <div className="team-selection">
                        <LabelText className="team-selection-text">SHOWING:</LabelText>
                        <CustomButton
                            color="primary"
                            endIcon={<KeyboardArrowDownIcon />}
                            onClick={() => {
                                setTimeLineDrawerOpen(true);
                                fetchMatchTimeline(
                                    startLoading,
                                    stopLoading,
                                    teamId,
                                    setMatches,
                                    setDisabledButtons,
                                    setSelectedSeasonId,
                                    selectedSeasonId,
                                    false,
                                    false,
                                    3,
                                    setTeamMatchesByMonth,
                                    setTimeLineTag,
                                    setSeasonName,
                                    true
                                );
                            }}
                        >
                            <LabelText className="player-search-text">{zoomLevelId === 4 ? "Overall" : timeLineTag}</LabelText>
                        </CustomButton>
                        <LabelNumber className="season-text"> {zoomLevelId !== 4 && `• ${zoomLevelId === 1 ? matchDate : seasonName}`}</LabelNumber>
                    </div>   
                )}
            </div>
            <Timeline
                isOpen={timeLineDrawerOpen}
                onClose={() => setTimeLineDrawerOpen(false)}
                teamId={teamId}
                seasonData={seasonData}
                teamMatchByMonthsData={teamMatchesByMonth}
                onConfirm={handleConfirm}
                zoomLevelId={zoomLevelId}
                selectedSeasonId={selectedSeasonId}
            />
            <MatchTimeLineWrapper className="match-timeline-wrapper" isTeamSelected={teamId !== 0}>
                    {selectedMatch >= 0 && zoomLevelId !== 1 ? (
                    <MatchTrackContainer className="match-track-container">
                        {teamId > 0 && displayedMatches?.length > 0 && zoomLevelId === 3 && groupIndex !== totalGroups - 1 && (
                        <SecondaryButton
                            className="arrow-left"
                            iconType="keyboardarrowleft"
                            onClick={handleLeftClick}
                            disabled={groupIndex === totalGroups - 1}
                        />
                        )}
                        <MatchTimeLine
                        matches={zoomLevelId === 4 ? [] : displayedMatches}
                        timelineDirection={direction}
                        onSelectMatchId={handleSelectMatch}
                        zoomLevel={zoomLevelId}
                        selectedMatchId={previousMatchId}
                        teamId={teamId}
                        />
                        {teamId > 0 && displayedMatches?.length > 0 && zoomLevelId === 3 && groupIndex !== 0 && (
                        <SecondaryButton
                            className="arrow-right"
                            iconType="keyboardarrowright"
                            onClick={handleRightClick}
                            disabled={groupIndex === 0}
                        />
                        )}
                    </MatchTrackContainer>
                    ) : (
                    <MatchTrackContainer className="match-track-container">
                        <EventTimeLine
                        matchId={selectedMatch}
                        injuryEvents={injuryEvents!!}
                        matchLevelEvents={matchLevelEvents}
                        matchEndTime={matchEndTime}
                        direction={direction}
                        />
                    </MatchTrackContainer>
                    )}
            
                    <div className="options-here">
                    <div className="zoom-level-buttons">
                        <SecondaryButton
                        iconType="keyboardarrowleft"
                        disabled={disabledButtons.previous}
                        onClick={() => toggleButtonState("previous")}
                        />
                        <SecondaryButton iconType="remove" disabled={disabledButtons.zoomOut} onClick={() => toggleButtonState("zoomOut")} />
                        <SecondaryButton iconType="add" disabled={disabledButtons.zoomIn} onClick={() => toggleButtonState("zoomIn")} />
                        <SecondaryButton iconType="keyboardarrowright" disabled={disabledButtons.next} onClick={() => toggleButtonState("next")} />
                    </div>
                    </div>
            </MatchTimeLineWrapper>
            {/* <div className="pitch-container-main" style={{background:'#ff000012'}}> */}
                <div className="pitch-container">
                    {teamId > 0 && (
                        <div className=" pitch-upper-filters pitch-upper-filters">
                        <div className="pitch-formation">
                            {timelineVisRestrictions[currentView][zoomLevelId] === "allow" && currentView !== "minus" && (
                            <>
                                <LabelText className="team-selection-text">FORMATION</LabelText>
                                <CustomButton
                                endIcon={<KeyboardArrowDownIcon style={{ color: 'black' }} />}
                                color="primary"
                                onClick={() => {
                                    setSidebarFormationOpen(!sidebarFormationOpen);
                                }}
                                >
                                <LabelText className="player-given-name">
                                    {(currentView === "systemFit" || currentView === "areasOfControl") &&
                                    formationData.find((form) => form.id === selectedFormation)?.formation}
                                    {(currentView === "passingNetwork" || currentPlayView === "flowOfPlay") &&
                                    PNFormationData.find((form) => form.id === selectedPNFormation)?.formation}
                                </LabelText>
                                </CustomButton>
                            </>
                            )}
                        </div>
                        <div className="pitch-performance">
                            {currentView === "passingNetwork" && (
                            <>
                                <LabelText className="player-given-name">Actual Positioning</LabelText>
                                <Switch
                                id="player-switch"
                                toggled={isActualPositionToggled}
                                onChange={handleActualPositionSwitchClick}
                                source="Filter"
                                isByComparison={false}
                                />
                            </>
                            )}
                        </div>
                        </div>
                    )}
                </div>
                <div className="pitch-block-start">
                    <div className="pitch-buttons-wrapper" style={{width: '100%',background:'#0000ff0a'}}>
                        <Pitch
                        //isPattern
                        isCorner
                        setSwapHoverPlayer={setSwapHoverPlayer}
                        passNetworkPlayers={passNetworkPlayers}
                        passNetworkPlayerPasses={passNetworkPlayerPasses}
                        currentView={currentView}
                        isIndividualPassing={isIndividualPassing}
                        setIsIndividualPassing={setIsIndividualPassing}
                        currentPlayView={currentPlayView}
                        selectedMatch={selectedMatch}
                        formationName={formationData.find((form) => form.id === selectedFormation)?.formation}
                        selectedTeam={teamId}
                        setPlayerCardID={setPlayerCardID}
                        gameModelData={gameModelData}
                        
                        />
                        {/* {isIndividualPassing && currentView === "passingNetwork" && (
                        <IndividualStatContainer className="individual-stat-container">
                            <div>
                            KEY PASSES <span>{individualStat?.totalKeyPasses}</span>
                            </div>
                            <div>
                            PROGRESSIVE PASSES <span>{individualStat?.totalProgressivePasses}</span>
                            </div>
                            <div>
                            SMART PASSES <span>{individualStat?.totalSmartPasses}</span>
                            </div>
                            <div>
                            LONG PASSES <span>{individualStat?.totalLongPasses}</span>
                            </div>
                            <div>
                            TOTAL PASSES <span>{individualStat?.totalPasses}</span>
                            </div>
                            <div>
                            ACCURACY <span>{individualStat?.accuracy}%</span>
                            </div>
                        </IndividualStatContainer>
                        )} */}
                        {playerCardID > 0 && playerCardDetails?.playerId! > 0 && (
                        <div className="pitch-widget-player-card" ref={playerCardRef}>
                            <PlayerLandingCard
                            key={playerCardDetails?.playerId!}
                            playerId={playerCardDetails?.playerId!}
                            givenName={playerCardDetails?.givenName!}
                            familyname={playerCardDetails?.familyname!}
                            playerImageURL={playerCardDetails?.playerImageURL!}
                            isInjured={playerCardDetails?.isInjured!}
                            onLoan={playerCardDetails?.onLoan!}
                            primaryPlayingPosition={playerCardDetails?.primaryPlayingPosition!}
                            age={playerCardDetails?.age!}
                            heightInCM={playerCardDetails?.heightInCM!}
                            playerAttributesByPosition={playerCardDetails?.playerAttributesByPosition!}
                            contributionValue={playerCardDetails?.contributionValue!}
                            performanceValue={playerCardDetails?.performanceValue!}
                            setPlayerCardDeatils={setPlayerCardDeatils}
                            setPlayerCardID={setPlayerCardID}
                            isPlayerInShortlist={playerCardDetails?.isPlayerInShortlist!}
                            isEasternPlayer={playerCardDetails?.isEasternPlayer!}
                            playerLabel={playerCardDetails?.playerLabel!}
                            archetypeName={playerCardDetails?.archetypeName!}
                            archetypeId={playerCardDetails?.archetypeId!}
                            />
                        </div>
                        )}
                    </div>
                </div>
               
                {/* {isNotification && notificationContent && (
                <PWNotification message={notificationContent} setIsNotification={setIsNotification} className="PWNotificationContainer" />
                )}
                <PitchInfo
                isOpen={informationShow}
                onClose={() => {
                    setSidebarPlayerShow(false);
                }}
                /> */}
            {/* </div> */}
            <FormationSelectDrawer
            sidebarFormationOpen={sidebarFormationOpen}
            setSidebarFormationOpen={setSidebarFormationOpen}
            formationData={currentView === "systemFit" || currentView === "areasOfControl" ? formationData : PNFormationData}
            // theme={theme}
            selectedFormation={currentView === "systemFit" || currentView === "areasOfControl" ? selectedFormation : selectedPNFormation}
            setSelectedFormation={
                currentView === "systemFit" || currentView === "areasOfControl" ? setSelectedFormation : handlePNFormationChange
            }
            // handleFormationChange={handleFormationChange}
            />
            {/* {loading && <LoadingSpinner />} */}
              <div className='attributes-table-main'>
                    {teamSegmentGameModelGroup?.map((section, index) => (
                        <div className='attributes-group-container' key={index}>
                        <div className='group-title-container'>
                            <LabelText className='player-given-name'>{section.title}</LabelText>
                        </div>
                        <div className='group-attributes-container'>
                            {section.Segments.map((attr, idx) => (
                                <>
                                    <div className='attribute-table-selection-item' key={idx}  style={{backgroundColor : selectedAttributes.includes(attr.key)? 'white' :'transparent'}}>
                                        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                                        <input
                                            type="checkbox"
                                            id={attr.key}
                                            className="custom-checkbox"
                                            name="game_model_attribute"
                                            value={attr.key}
                                            checked={selectedAttributes.includes(attr.key)}
                                            onChange={() => handleGameModelAttributesSelection(attr.key)}
                                        />
                                        <div style={{height:'9px',width:'9px',borderRadius:'2px',background:attr.color}}></div>
                                        <LabelText style={{color:attr.color}}>{attr.label}</LabelText>
                                        </div>
                                        
                                    </div>
                                    {/* <Line/> */}
                                </>
                            ))}
                        </div>
                        </div>
                    ))}
                </div>
        </div>

    )
}

export default Possessions;